'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeTimeSeriesIcon = function TraceTypeTimeSeriesIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', { stroke: '#25fdfc', d: 'M7 6v31M23 6v31M15 6v34M31 6v34m8-34v31', strokeMiterlimit: '10', strokeWidth: '2' }),
            _react2.default.createElement('path', { d: 'M0 0h46v46H0z' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M5.13 24.645L11 29l4-6.871 3.458 2.516L23 17.29l3.917 10.032L31 15.451 35.082 24l4.168-4.355 2.054-5.71', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M4 39h6m2 3h6m2-3h6m2 3h6m2-3h6', strokeLinejoin: 'round', strokeWidth: '2' })
        )
    );
};

exports.default = TraceTypeTimeSeriesIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeTimeSeriesIcon.js
// module id = 734
// module chunks = 0